import { FC } from 'react'
import styles from 'components/features/coaching/advisorPage/HowItWorks/HowItWorks.styl'

type HowItWorksProps = {}
const HowItWorks: FC<HowItWorksProps> = () => {
  return (
    <ul className={ styles.howItWorks } data-qa-marker='how-it-works-section'>
      <li>
        <h3 data-qa-marker='header'>Get expert financial advice and coaching every month.</h3>
      </li>
      <li>
        <h4 data-qa-marker='1-pick-a-topic'>1. PICK A TOPIC</h4>
        <p data-qa-type='data'>
          Tell us a bit about what you want to talk about and we’ll match you to the best suited expert.
        </p>
      </li>

      <li>
        <h4 data-qa-marker='2-pick-a-time'>2. PICK A TIME</h4>
        <p data-qa-type='data'>
          Select a timeslot that works for you. We’ll email you the session link.
        </p>
      </li>

      <li>
        <h4 data-qa-marker='3-meet-your-coach'>3. MEET YOUR COACH</h4>
        <p data-qa-type='data'>
          Click the session link at the scheduled time to video chat with your coach.
        </p>
      </li>
    </ul>
  )
}

export default HowItWorks
